import { render, staticRenderFns } from "./BarcodeOrderTable.vue?vue&type=template&id=2c296616&scoped=true"
import script from "./BarcodeOrderTable.vue?vue&type=script&lang=ts"
export * from "./BarcodeOrderTable.vue?vue&type=script&lang=ts"
import style0 from "./BarcodeOrderTable.vue?vue&type=style&index=0&id=2c296616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c296616",
  null
  
)

export default component.exports